import React from 'react';
import { set } from 'dot-prop-immutable';
import { connect } from 'react-redux';
import moment from 'moment';
import { getParentElementWithChildren, getParentFormWidthChildren } from '@whalecloud/page-builder-core/selectors';
import { toolFormAttr, toolCollapseAttr, getLocale, getTypeArr, handleInputType } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch, Select } from '@whalecloud/fdx';
import CustomInput from '@whalecloud/page-builder-base-components/components/CustomInput';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import CommonDateSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonDateSettings';

const { Panel } = Collapse;
const { Option } = Select;

const valueKey = 'data.formItemSettings';
const formKey = 'data.formSettings';

const TimePickerSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, activateElement, parentElement, element, formElement } = props;
  const { data: { formItemSettings = {}, formSettings = {} } = {} } = element;

  const {
    showNow = false,
    hourStep = 1,
    minuteStep = 1,
    secondStep = 1,
  } = formItemSettings;

  const initialValues = {
    showNow,
    hourStep,
    minuteStep,
    secondStep,
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      const value = obj[key];
      let newElement;
      if (key === 'type') {
        const getHandle = handleInputType(element, propName, value, parentElement, valueKey, formKey);
        newElement = getHandle?.newElement;
        if (getHandle?.getElement) activateElement({ element: getHandle?.getElement?.id });
      } else if(key === 'showNow') {
        let showTodayValue = {
          value: moment().format(formItemSettings.format),
          format: formItemSettings.format
        };
        if (!value) {
          showTodayValue = {};
        }
        handleInitialValues(formSettings.name, showTodayValue);
      }
      newElement = set(element, propName, value);
      updateElement({
        element: newElement,
      });
    });
  };

  const handleInitialValues = (name, value) => {
    if (formElement) {
      const propName = `data.formSettings.initialValues.${name}`
      const newElement = set(formElement, propName, value);
      updateElement({
        element: newElement,
      });
    }
  }
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages.PAGEBUIDER_SETTINGS} key="1">
        <CommonItemSettings />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_SHOW_NOW} name="showNow" valuePropName="checked" >
            <Switch />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_HOUR_STEP} name="hourStep">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_MINUTE_STEP} name="minuteStep">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_SECOND_STEP} name="secondStep">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
        </Form>
        <CommonDateSettings pickerFormat="HH:mm:ss" />
      </Panel>
    </Collapse>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  activateElement: (payload: any) => {
    dispatch({
      type: 'ui/activateElement',
      payload,
    });
  },
});

export default connect<any, any, any>(
  (state, { element }) => {
    return { 
      parentElement: getParentElementWithChildren(state, element.id),
      formElement: getParentFormWidthChildren(state, element.id)
    };
  },
  mapDispatchToProps,
)(React.memo(TimePickerSettings));
